import React from 'react';
import AppBar from "@material-ui/core/AppBar/AppBar";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Typography from "@material-ui/core/Typography/Typography";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import MenuIcon from '@material-ui/icons/Menu';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AccountBox from '@material-ui/icons/AccountBox';
import GroupWork from '@material-ui/icons/GroupWork';
import AccountBalance from '@material-ui/icons/AccountBalance';
import Category from '@material-ui/icons/Category';
import Score from '@material-ui/icons/Score';
import Store from '@material-ui/icons/Store';
import Check from '@material-ui/icons/Check';
import ExitToApp from '@material-ui/icons/ExitToApp';
import ContentHOC from './content/contentHOC';
import {_isAdmin} from "../../helpers/functions";
import './layout.css';
import images from "../../assets/images/images";
const drawerWidth = 260;

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflowY: 'scroll',
    position: 'relative',
    display: 'flex',
    height: '100%'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    height: '57px',
  },
  content: {
    width: '100vh',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
  toolbarImg: {
    height: '100%'
  },
  '@media screen and (max-width: 768px)': {
    drawerPaperClose: {
      width: '0px'
    }
  }
});


const Layout = (props) => {
  return (
    <div className={'container-fluid p-0 container-fill'}>
      <div className={props.classes.root}>
        <AppBar position="absolute" className={classNames(props.classes.appBar, props.isDrawerOpen && props.classes.appBarShift)}>
          <Toolbar disableGutters={!props.isDrawerOpen}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => props.openDrawer()}
              className={classNames(props.classes.menuButton, props.isDrawerOpen && props.classes.hide)}
            >
              <MenuIcon/>
            </IconButton>
            <Typography variant="h6" color="inherit" style={styles.flex}>
              Franchisee Ranking
            </Typography>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(props.classes.drawerPaper, !props.isDrawerOpen && props.classes.drawerPaperClose),
          }}
          open={props.isDrawerOpen}
        >
          <div className={props.classes.toolbar}>
            <img
              style={{cursor: 'pointer'}}
              onClick={() => props.history.push('/score-records')}
              className={ classNames(props.classes.toolbarImg,'img-responsive')}
              src={images.ciLogo} alt=""
            />
            <IconButton onClick={() => props.closeDrawer()}>
              {props.theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>
          <Divider />
          <List>
            <div>
              <ListItem button onClick={() => props.history.push('/score-records')}>
                <ListItemIcon>
                  <Score />
                </ListItemIcon>
                <ListItemText primary="Score Records" />
              </ListItem>
              { (_isAdmin(props.personRoles)) && (
                <ListItem button onClick={() => props.history.push('/persons')}>
                  <ListItemIcon>
                    <AccountBox />
                  </ListItemIcon>
                  <ListItemText primary="Persons" />
                </ListItem>
              )}
              { (_isAdmin(props.personRoles))  && (
                <ListItem button onClick={() => props.history.push('/departments')}>
                  <ListItemIcon>
                    <GroupWork />
                  </ListItemIcon>
                  <ListItemText primary="Departments" />
                </ListItem>
              )}
              { (_isAdmin(props.personRoles)) && (
                <ListItem button onClick={() => props.history.push('/pillars')}>
                  <ListItemIcon>
                    <AccountBalance />
                  </ListItemIcon>
                  <ListItemText primary="Pylons" />
                </ListItem>

              )}
              {(_isAdmin(props.personRoles)) && (
                <ListItem button onClick={() => props.history.push('/categories')}>
                  <ListItemIcon>
                    <Category />
                  </ListItemIcon>
                  <ListItemText primary="Categories" />
                </ListItem>
              )}
              {
                _isAdmin(props.personRoles) && (
                  <ListItem button onClick={() => props.history.push('/criteria')}>
                    <ListItemIcon>
                      <Check />
                    </ListItemIcon>
                    <ListItemText primary="Criteria" />
                  </ListItem>
                )
              }
              {
                _isAdmin(props.personRoles) && (
                  <ListItem button onClick={() => props.history.push('/stores')}>
                    <ListItemIcon>
                      <Store />
                    </ListItemIcon>
                    <ListItemText primary="Stores" />
                  </ListItem>
                )
              }
              <ListItem button onClick={() => props.logout({token: props.token})}>
                <ListItemIcon>
                  <ExitToApp />
                </ListItemIcon>
                <ListItemText primary="Log out" />
              </ListItem>
            </div>
          </List>
          <Divider />
        </Drawer>
        <main className={props.classes.content}>
          <div className={props.classes.toolbar} />
          <ContentHOC/>
        </main>
      </div>
    </div>
  )
};

export default withStyles(styles, { withTheme: true })(Layout);



// WEBPACK FOOTER //
// ./src/components/layout/layout.js